<template>
  <div class="box">
      <template v-if="audioId==16">
          <div class="audiodetail_top" style="height:100%;background-image: url('/static/img/gecibg.png');background-size: 100% 100%;position:fixed;top:0;left:0;">
              <div class="audio_caozuo2">
                  <!-- <img src="/static/img/xiazai_audio.png" @click="toxiazai" class="xiazai_audio"  v-show="isshowfenxiang">
                  <img src="/static/img/fenxiang_audio.png" @click="tofenxiang" class="fenxiang_audio"> -->
              </div>
              <img src="/static/img/ximalaya_audio.png" class="ximalaya_audio" @click="toximalaya" v-if="details.audioLink">
              <img src="/static/img/atoshi_logo.png" class="atoshi_logo">
              <img :src="contralImg" class="contral" data-action='play' id='btn-play'>
              <div class="audio_title" @click="toshowtitle">{{details.audioTitle}}</div>
              <div class="biaozhunxian" id="biaozhunxian">
                  <p>---------</p>
                  <p>---------</p>
              </div>
              <div class="geci" id="geci">
                  <div id="geci_cont" ref="gecicont">
                      <ul id="lrclist"><!-- 保證歌詞在正中間 -->

                      </ul>
                  </div>
              </div>
              <div class="jAudio--progress-bar" style="margin-bottom:0.2rem;">
                  <div class='jAudio--progress-bar-wrapper'>
                      <div class='jAudio--progress-bar-played'>
                          <span class='jAudio--progress-bar-pointer'></span>
                      </div>
                  </div>
              </div>
              <div class='jAudio--time' style="margin-bottom:0.3rem;">
                  <span class='jAudio--time-elapsed'>00:00</span>
                  <span class='jAudio--time-total'>00:00</span>
              </div>
              <audio :src="details.audioFileUrl"  id="audio_wenjian" style="opacity:0;"></audio>
          </div>
          <div class="audiodetail_des" id="des1" style="width:7.5rem;height:1rem;padding: 0.6rem 0.6rem;padding-bottom:0.8rem;position: fixed;bottom:0;left:0;background:#ffffff;" v-if="!iszhankai" @click="tozhankai()">
              <div class="audiodetail_des_title">介紹</div>
              <img src="../assets/zhankai.png" class="zhankai" @click.stop="tozhankai()">
          </div>
          <div class="zhezhaoceng" v-if="iszhankai" @click.self="toshouqi()">
              <div class="audiodetail_des zhankai_box" id="des2" style="position:absolute;bottom:0;left:0;height:auto;background: #ffffff;">
                  <div class="audiodetail_des_title">介紹</div>
                  <img src="../assets/zhankai.png" class="shouqi" @click.stop="toshouqi()" style="transform:rotate(180deg);">
                  <div class="audiodetail_des_cont shouqi_des">{{details.audioIntroduce?details.audioIntroduce:'暫無介紹'}}</div>
              </div>
          </div>
      </template>
      <template  v-if="audioId!=16">
          <div class="audiodetail_top">
              <img src="/static/img/ximalaya_audio.png" class="ximalaya_audio" @click="toximalaya" v-if="details.audioLink">
              <img :src="contralImg" class="contral" data-action='play' id='btn-play'>
              <div class="audio_title martop" @click="toshowtitle">{{details.audioTitle}}</div>
              <div class="audio_caozuo2">
                  <!-- <img src="/static/img/xiazai_audio.png" @click="toxiazai" class="xiazai_audio" v-show="isshowfenxiang">
                  <img src="/static/img/fenxiang_audio.png" @click="tofenxiang" class="fenxiang_audio"> -->
              </div>
              <div class="jAudio--progress-bar martop2">
                  <div class='jAudio--progress-bar-wrapper'>
                      <div class='jAudio--progress-bar-played'>
                          <span class='jAudio--progress-bar-pointer'></span>
                      </div>
                  </div>
              </div>
              <div class='jAudio--time'>
                  <span class='jAudio--time-elapsed'>00:00</span>
                  <span class='jAudio--time-total'>00:00</span>
              </div>
              <audio :src="details.audioFileUrl"  id="audio_wenjian" style="opacity:0;"></audio>
          </div>
          <div class="audiodetail_des">
              <div class="audiodetail_des_title">介紹</div>
              <div class="audiodetail_des_cont">{{details.audioIntroduce?details.audioIntroduce:'暫無介紹'}}</div>
          </div>
      </template>
    <div class="webdown_box" v-show="isshowzhezhao" @click="toguanbi">
       <img src="/static/img/right_share.png">
    </div>
  </div>
</template>

<script>
  import { enums } from "../../../enum";
  export default {
    name: "audiodetail",
    data() {
      return {
          audioId:'',
          details:{},
          contralImg:'',
          action:false,
          userAgent:null,
          isshowcaozuo:false,
          isshowzhezhao: false,
          iszhankai:false,
          isshowfenxiang: false,
      }
    },
    methods: {
        toshowtitle(){
            this.$dialog.alert({
                message: this.details.audioTitle,
                width:300
            });
        },
        tozhankai(){
            this.iszhankai=true
        },
        toshouqi(){
            this.iszhankai=false
        },
        getDetails(){
            this.$axios.post('api/audio/findAudioById',{audioId:this.audioId}).then(res => {
                this.details = res.data.data.data;
                this.contralImg='/static/img/bofang_audio.png'
                $(".audiodetail_top").jAudio();
                if (this.audioId==16) {
                    this.gecishishi()
                }
            })
        },
        gecishishi(){
            var _this=this
            var lrcJSON = {
                "[00:1.88]":"小原子也可以點亮世界",
                "[00:19.71]":"詞麯：嶽明華/廖望",
                "[00:26.81]":"人就像一顆原子",
                "[00:29.24]":"很微小，但潛力無限",
                "[00:32.03]":"鏈接釋放的能量",
                "[00:35.55]":"可以點亮世界",
                "[00:39.01]":"星火燎原",
                "[00:41.21]":"每天點亮一個角落",
                "[00:44.29]":"給世界加一點能量",
                "[00:51.41]":"原子鏈",
                "[00:53.84]":"鏈接你我",
                "[00:56.73]":"鏈接未來",
                "[01:02.40]":"嚮公正平等更加高效的明天",
                "[01:08.40]":"奔跑而去",
                "[01:09.48]":"我們的生命為它歡騰",
                "[01:15.00]":"原子幣",
                "[01:17.03]":"像一顆堅實的種子",
                "[01:20.46]":"破土而出",
                "[01:21.39]":"頂著烈日",
                "[01:23.00]":"迎著風雨",
                "[01:26.43]":"嚮枝繁葉茂的春天",
                "[01:31.84]":"野蠻生長",
                "[01:33.00]":"我們的腳步為它而奔騰",
                "[01:39.09]":"讓我們手牽手",
                "[01:44.17]":"一起點亮世界！",
                "[01:51.23]":"讓我們心連心",
                "[01:56.67]":"一起點亮世界！",
                "[02:03.11]":"讓我們鏈接一起",
                "[02:05.92]":"盡情釋放我們的潛能！",
                "[02:09.18]":"一起點亮世界！",
                "[02:14.86]":"一起點亮世界！",
                "[02:20.52]":"一起點亮世界！",
                "[02:49.00]":""
            };
            var lrcTime = [];//歌詞對應的時間數組
            var ul = $("#lrclist")[0];//獲取ul

            var i = 0;
            $.each(lrcJSON, function(key, value) {//遍曆lrc
                lrcTime[i++] = parseFloat(key.substr(1,3)) * 60 + parseFloat(key.substring(4,10));//00:00.000轉化為00.000格式
                ul.innerHTML += "<li><p>"+lrcJSON[key]+"</p></li>";//ul裏填充歌詞
            });
            lrcTime[lrcTime.length] = lrcTime[lrcTime.length-1] + 3;//如不另加一個結束時間，到最後歌詞滾動不到最後一句

            var geci_cont=document.getElementById('geci_cont');
            var $li = $("#lrclist>li");//獲取所有li

            var currentLine = 0;//當前播放到哪一句了
            var currentTime;//當前播放的時間
            var audio = document.getElementById("audio_wenjian");
            var ppxx;//保存ul的translateY值

            audio.ontimeupdate = function() {//audio時間改變事件
                currentTime = audio.currentTime;
                var j,len
                for (j=currentLine, len=lrcTime.length; j<len; j++){
                    if (currentTime<lrcTime[j+1] && currentTime>lrcTime[j]){
                        currentLine =  j;
                        let y = -40*currentLine
                        $('#geci_cont').find("li").removeClass("on");
                        $li.get(currentLine).className="on";
                        $('#geci_cont').css({top: (y/50)+'rem' });
                        break;
                    }
                }
            };

            audio.onseeked = function() {//audio進度更改後事件
                $("#lrclist").find("li").removeClass("on");
                currentTime = audio.currentTime;
                if(currentTime<1){
                    $("#geci_cont").css({
                        top: '0.4rem',
                    }); //控件新位置
                }
                var k,len
                for (k=0, len=lrcTime.length; k<len; k++){
                    if (currentTime<lrcTime[k+1] && currentTime>lrcTime[k]){
                        currentLine =  k;
                        break;
                    }
                }
            };
            audio.addEventListener('play', function () {
                $(".contral_top").attr('src','/static/img/zanting.png');
                $(".contral").attr('src','/static/img/zanting_audio.png');
                $(".contral").data("action", "pause");
                $(".contral").attr("id", "btn-pause");
                audio.play()
            }, false);
            audio.addEventListener('pause', function () {
                $(".contral_top").attr('src','/static/img/bofang.png');
                $(".contral").attr('src','/static/img/bofang_audio.png');
                $(".contral").data("action", "play");
                $(".contral").attr("id", "btn-play");
                audio.pause()
            }, false);
            audio.addEventListener('ended', function () {
                $("#lrclist").html(' ')
                _this.gecishishi()
                $(".contral_top").attr('src','/static/img/bofang.png');
                $(".contral").attr('src','/static/img/bofang_audio.png');
                $(".contral").data("action", "play");
                $(".contral").attr("id", "btn-play");
                audio.pause()
            }, false);

            var _move = false; //移動標記
            var _y; //滑鼠離控件左上角的相對位置
            var line=0;
            $(document).ready(function() {
                document.getElementById('geci_cont').addEventListener("touchstart",function(e){
                    _move = true;
                    var touch = e.touches[0]; //獲取第一個觸點
                    _y = Number(touch.pageY) - parseInt($('#geci_cont').css("top"));
                },false);
                document.addEventListener("touchmove",function(e){
                    e.preventDefault()
                    if(parseInt($('#geci_cont').css("top"))<-1280)
                    {
                        _move = false;
                        return ;
                    }
                    if(parseInt($('#geci_cont').css("top"))>20)
                    {
                        $('#geci_cont').css({
                            top: "0.4rem",
                        });
                        _move = false;
                        return ;
                    }
                    if(_move) {
                        // audio.pause();
                        // console.log(parseInt($("#treeDiv").css("top")),parseInt($("#treeDiv").css("top"))/30,parseInt(Math.abs(parseInt($("#treeDiv").css("top")))/40));
                        //拖動後的第幾行
                        line = parseInt(Math.abs(parseInt($("#geci_cont").css("top")))/40);
                        $li.get(line).className="on";
                        audio.currentTime = lrcTime[line]
                        currentLine=line

                        var touch = e.touches[0]; //獲取第一個觸點
                        var y = Number(touch.pageY) - _y;

                        $('#geci_cont').css({
                            top: (y/50)+"rem",
                        }); //控件新位置
                    }
                },false);
                document.addEventListener("touchend",function(e){
                    if (_move) {
                        _move = false;
                        // audio.play();
                    }
                },false);
            });
        },
        toximalaya(){
            location.href = this.details.audioLink
        },
        toxiazai(){
            var isWeixin = !!/MicroMessenger/i.test(this.userAgent);
            if (isWeixin) {
                this.$dialog.alert({
                    message: '點選右上角按鈕，然後再彈出的菜單中，點選在Safari中打開，即可下載該音頻',
                    width:250
                });
            } else {
                if (this.userAgent.indexOf("android") > -1) {
                    window.Android.downloadAudio(this.details.audioFileUrl,this.details.audioFileName);
                } else if (/^.+(Mobile\/\w+)\s?$/.test(this.userAgent)) {
                    window.webkit.messageHandlers.callCustomerServiceiOS.postMessage(pho);
                } else {
                    location.href=enums.address+'/api/audio/downloadAudio?audioName='+this.details.audioFileName
                }
            }
        },
        tofenxiang(){
            let _this=this
            if (_this.userAgent.indexOf("android") > -1) {
                window.Android.shareNewsFromWebsite(_this.details.audioTitle,_this.details.audioFileUrl,_this.details.readCover);
            } else if (/^.+(Mobile\/\w+)\s?$/.test(_this.userAgent)) {
                let datas=JSON.stringify({fxtitle:_this.details.audioTitle,fxurl:_this.details.audioFileUrl,fxcoverimg:_this.details.readCover})
                window.webkit.messageHandlers.shareNewsToiPhone.postMessage(datas);
            } else {
                // _this.isshowzhezhao = true
                this.$dialog.alert({
                    message: '請點選瀏覽器分享按鈕進行分享',
                    width:250
                });
            }
        },
        toguanbi () {
            this.isshowzhezhao = false
        },
    },
    mounted() {
        this.audioId=this.$route.query.audioId
        this.getDetails()
        this.userAgent = navigator.userAgent;
        if (this.userAgent.indexOf("android") > -1) {
            this.isshowfenxiang=true
        } else if (/^.+(Mobile\/\w+)\s?$/.test(this.userAgent)) {
            this.isshowfenxiang=false
        } else {
            this.isshowfenxiang=true
        }
    }
  }
</script>

<style scoped>
    .box {
        width: 100%;
        height: 100%;
        background: #ffffff;
    }
    .audiodetail_top{
        width:7.5rem;
        min-height:7rem;
        margin:0 auto;
        background-image: url("/static/img/audio_bg.png");
        background-repeat:  no-repeat;
        background-size: contain;
        position: relative;
    }
    .audio_caozuo2{
       
        position: absolute;
        top:0.3rem;
        right:0.3rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;

    }
    .ximalaya_audio{
        position: absolute;
        top:0.3rem;
        right:0.3rem;
        width:1.2rem;
        height:0.4rem;
    }
    .atoshi_logo{
        position: absolute;
        top:1.11rem;
        left:2.55rem;
        width:2.4rem;
        height:2.4rem;
        border-radius: 0.16rem;
        z-index: 0;
    }
    .contral{
        width:1.2rem;
        height:1.2rem;
        cursor:pointer;
        margin-top:1.75rem;
        margin-left:3.15rem;
        position: relative;
        z-index: 10;
    }
    .audio_title{
        width:90%;
        font-size:0.42rem;
        color:#ffffff;
        margin:0 auto;
        margin-top:0.8rem;
        text-align: center;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .audio_caozuo{
        width:2.4rem;
        margin:0 auto;
        margin-top:0.23rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
    }
    .xiazai_audio, .fenxiang_audio{
        width:1.1rem;
        height:0.4rem;
        margin-left: 5px;
    }
    .audiodetail_des{
        width:6.7rem;
        margin:0 auto;
        margin-top:0.42rem;
    }
    .audiodetail_des_title{
        height:0.29rem;
        line-height:0.31rem;
        color:#333333;
        font-size:18px;
        padding-left:0.1rem;
        border-left:0.05rem solid #00A0EA;
    }
    .audiodetail_des_cont{
        width:100%;
        font-size: 0.28rem;
        color:#666666;
        margin-top:0.25rem;
        line-height: 0.52rem;
    }
    .webdown_box{
        width:100%;
        min-height: 100vh;
        position:fixed;
        background:rgba(0,0,0,.65);
        z-index:200;
        top:0;
    }
    .webdown_box img{
        width:3.5rem;
        position:absolute;
        top:0;
        right:0;
        z-index: 300;
    }
    .zhankai{
        width:0.45rem;
        position:absolute;
        top:0.45rem;
        right:0.6rem;
    }
    .shouqi{
        width:0.45rem;
        position:absolute;
        top:0.4rem;
        right:0.6rem;
    }
    .zhankai_box{
        width:7.5rem;
        padding: 0.6rem 0.6rem;
    }
    .shouqi_des{
        min-height:1.5rem;
        max-height:4.5rem;
        overflow-y:scroll;
    }
    .zhezhaoceng{
        width:100%;
        height:100%;
        position: fixed;
        top:0;
        left:0;
        background: rgba(0,0,0,.45);
    }
    .biaozhunxian p:nth-child(1)
    {
        position: absolute;
        top: 7rem;
        left:0.34rem;
        color:#00A0EA;
    }
    .biaozhunxian p:nth-child(2)
    {
        position: absolute;
        top: 7rem;
        right: 0.34rem;
        color:#00A0EA;
    }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/audiodetail.vue